import { get } from 'lodash';
import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('login');

const reducer = handleActions(
  {
    [actions.api.login.request]: (_, { payload }) => ({
      isFetching: get(payload, 'noRefresh', false) ? false : true,
      isError: false,
    }),
    [actions.api.login.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.login.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
    [actions.api.login.setstate]: (state, { payload }) => ({
      ...state,
      ...payload
    })
  },
  { ...apiModuleDefaultState, data: {}, error: null }
);

export default reducer;
